import { memo } from 'react';

import { ColumnTypes, Modal, TableWithActions } from '..';
import { useLogic } from './logic';
import { JoinProgramModalViewProps } from './type';

const JoinProgramModalView = (props: JoinProgramModalViewProps) => {
	const { ...rest } = props;

	const {
		dataSource,
		columns,
		rowSelection,
		openModal,
		nameApplicant,
		listIds,

		onToggle,
		handleSave,
	} = useLogic(props);

	return (
		<div>
			<Modal
				open={openModal}
				onCancel={onToggle}
				labelButton="저장"
				onClickButton={handleSave}
				{...rest}
			>
				<div className="bg-white">
					<div className="mb-2.5">
						<label className="text-sm leading-4 font-bold">근로자</label>
						<p className="text-[13px] leading-[15px] font-medium pb-10">
							{listIds && listIds?.length > 1
								? `${nameApplicant} 외 ${(listIds?.length ?? 0) - 1} 명`
								: `${nameApplicant}`}
						</p>
						<label className="text-sm leading-4 font-bold">프로그램</label>
					</div>

					<TableWithActions
						actionHidden
						columns={columns as ColumnTypes}
						dataSource={dataSource}
						rowSelection={rowSelection}
						pagination={false}
						scroll={{ y: 520 }}
						rowKey={'id'}
						containerClassName="!p-0"
					/>
				</div>
			</Modal>
		</div>
	);
};

export default memo(JoinProgramModalView);
